module.exports = __webpack_public_path__ + "img/fondo-slider.c43e0d12.png";